<template>
  <svg class="icon" xmlns="http://www.w3.org/2000/svg">
   <g class="scale">
    <path transform="rotate(179.917 7.52111 8.5)" stroke="null" id="svg_1" d="m7.916082,15.298161l0,1.566586l-2.566366,-2.180875l0,2.197068l-2.562396,-2.234512l2.562396,-2.201116l0,2.164682l2.566366,-2.180875l0,1.291321c3.114195,-0.130548 5.449329,-2.71319 5.500935,-5.908096l-1.023171,0l0.015878,-0.217584l1.007294,0c-0.059545,-3.228303 -2.609038,-5.83422 -5.774839,-5.903038l0,1.030224l-0.212375,0l0,-1.03326c-3.185628,0.047564 -5.756956,2.662592 -5.817492,5.906074l1.037066,0l-0.015879,0.217584l-1.037066,0c-0.051605,0.291457 -0.315586,0.66185 -0.760187,0.66185c-0.533915,0 -0.749267,-0.489809 -0.749267,-0.759004c0,-4.195782 3.305712,-7.596127 7.419241,-7.596127c4.114542,0 7.449031,3.400345 7.449031,7.596127c0,4.107738 -3.042721,7.445336 -7.039166,7.582971"/>
    <text xml:space="preserve" text-anchor="start" font-family="Helvetica, Arial, sans-serif" font-size="9" id="svg_4" y="12.083997" x="2.24976" fill-opacity="null" stroke-opacity="null" stroke-width="0" stroke="null" >10</text>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'JumpForwardIcon',
}
</script>

<style lang="scss" scoped>
.icon {
  padding: 5px;
  cursor: pointer;
  font-size: 1.5rem;
  width: 40px;
  height: 32px;
  fill: white;
}

.scale {
  transform: scale(1.2);
}
</style>



// WEBPACK FOOTER //
// JumpForwardIcon.vue?71ea5118